import { useQuery } from '@tanstack/react-query';
import type { DepartmentDto, HolidayCalendarDto, WorkScheduleDto } from '@workforce/shared';
import { api } from './api';

export interface ReferenceData {
  countries: { code: string; name: string }[];
  timeZones: { zone: string; offset: string }[];
  employmentTypes: { value: string; label: string }[];
  employmentStatuses: { value: string; label: string }[];
  workArrangements: { value: string; label: string }[];
}

export const useReference = () =>
  useQuery({ queryKey: ['reference'], queryFn: () => api.get<ReferenceData>('/meta/reference'), staleTime: 3_600_000 });

export const useDepartments = (enabled = true) =>
  useQuery({ queryKey: ['departments'], queryFn: () => api.get<DepartmentDto[]>('/departments'), enabled });

export const useSchedules = (enabled = true) =>
  useQuery({ queryKey: ['schedules'], queryFn: () => api.get<WorkScheduleDto[]>('/schedules'), enabled });

export const useCalendars = (enabled = true) =>
  useQuery({ queryKey: ['holiday-calendars'], queryFn: () => api.get<HolidayCalendarDto[]>('/holiday-calendars'), enabled });

export const useEmployeeOptions = (enabled = true) =>
  useQuery({
    queryKey: ['employees', 'options'],
    queryFn: () => api.get<{ id: string; fullName: string; employeeCode: string }[]>('/employees/options'),
    enabled,
  });
